import { Grid } from "@material-ui/core"
import { TextButton, Elements } from "@tfo/common"
import React, { useEffect } from "react"
import { useIntl } from "react-intl"
import CustomerPortalDialog from "../../../containers/client/common/CustomerPortalDialog"
import { NewOrderData } from "@tfo/common/src/models"
import $http from "../../../utils/$http"
import { CustomerUser } from "../../../models/IGroupSummary"
import { useStore } from "../../../hooks"

const { Paragraph } = Elements

const OrderConfirmationModal = ({ open, onClose, onSubmit, formData, companyName }:
    { open: boolean, onClose: () => void, onSubmit: () => void, formData: NewOrderData, companyName: string }) => {
    const intl = useIntl()
    const rootStore = useStore()
    const reportPackageName = rootStore.clientViewStore.selectedReportPackage.customName
    const [reportRecipient, setReportRecipient] = React.useState<string>('')

    useEffect(() => {
        const getReportRecipient = async (userId: number) => {
            const response = await $http.get<CustomerUser>(`/user/customer/${userId}`)
            setReportRecipient(`${response.firstName} ${response.lastName}`)
        }

        if (formData.additionalOrderRecipientUserId.value) {
            getReportRecipient(formData.additionalOrderRecipientUserId.value)
        }
    }, [open])

    const confirmationDetails = [
        { [intl.formatMessage({ id: 'new.report.order.form.modal.order.confirmation.company' })]: companyName },
        { [intl.formatMessage({ id: 'new.report.order.form.modal.order.confirmation.reportPackage' })]: reportPackageName },
				formData.nationalId ? {[intl.formatMessage({ id: 'new.report.order.form.modal.order.confirmation.nationalId' })]: formData.nationalId.value } : null,
				formData.birthDate ? {[intl.formatMessage({ id: 'new.report.order.form.modal.order.confirmation.birthDate' })]: formData.birthDate.value } : null,
        { [intl.formatMessage({ id: 'new.report.order.form.modal.order.confirmation.individualName' })]: `${formData.firstName.value} ${formData.lastName.value}` },
        { [intl.formatMessage({ id: 'new.report.order.form.modal.order.confirmation.mobile' })]: formData.phoneNumber.value ? formData.phoneNumber.value : '-' },
        { [intl.formatMessage({ id: 'new.report.order.form.modal.order.confirmation.email' })]: formData.email.value },
        ...(
            formData.optionalCheckpoints.length > 0
                ? [
                    {
                        [intl.formatMessage({ id: 'new.report.order.form.modal.order.confirmation.includeCurrentEmployment' })]:
                            formData.optionalCheckpoints.find(c => c.checkpointType === 'CurrentEmployment'
                                || c.checkpointType === 'InternationalResumeCurrentEmployment')?.isIncluded
                                ? [intl.formatMessage({ id: 'new.report.order.form.modal.order.confirmation.yes' })]
                                : [intl.formatMessage({ id: 'new.report.order.form.modal.order.confirmation.no' })]
                    }
                ]
                : []
        ),
        ...(
            formData.countriesBackgroundCheck.length > 0
                ? [{ [intl.formatMessage({ id: 'new.report.order.form.modal.order.confirmation.country' })]: formData.countriesBackgroundCheck.map(c => c.country).join(', ') }]
                : []
        ),
        { [intl.formatMessage({ id: 'new.report.order.form.modal.order.confirmation.additionalOrderRecipient' })]: reportRecipient },
        { [intl.formatMessage({ id: 'new.report.order.form.modal.order.confirmation.invoiceComment' })]: formData.invoiceReference.value },
    ]

    return (
        <>
            <CustomerPortalDialog
                open={open}
                onClose={onClose}
                title={intl.formatMessage({ id: 'new.report.order.form.modal.order.confirmation.title' })}
                content={
                    <>
                        <Grid container spacing={3} direction="row">
                            {confirmationDetails.filter(cmd => !!cmd).map((item) => {
                                const [label, value] = Object.entries(item)[0];
                                return (
                                    <>
                                        <Grid item xs={6}>
                                            <Paragraph>{label}:</Paragraph>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Paragraph>{value}</Paragraph>
                                        </Grid>
                                    </>
                                )
                            })}
                        </Grid>
                    </>
                }
                footer={
                    <Grid container spacing={2} justifyContent={'center'}>
                        <Grid item xs={6} md={5}>
                            <TextButton onClick={onSubmit} >
                                {intl.formatMessage({ id: 'new.report.order.form.modal.order.confirmation.confirm' })}
                            </TextButton>
                        </Grid>
                    </Grid>
                }
            />
        </>
    )
}

export default OrderConfirmationModal
